// import { SiOpenaigym } from 'react-icons/si';
// import { MdEventAvailable } from "react-icons/md"
import TrishImg from '../img/photos/Trish_v3_sq.png';
import AmyImg from '../img/photos/Amy_v2.png';
import HelenImg from '../img/photos/Helen-cropped-cc_v2.png';
import KaitImg from '../img/photos/Kait_v2_bgd_blur.png';
import BruceImg from '../img/photos/Bruce_F - sm.jpg';
import AM_YT from '../img/graphics/aphasia_moments.png';

import fbIcon from "../img/icons/fb.png";
import emailIcon from "../img/icons/email.png";
// import etsyIcon from "../img/icons/etsy.png";
// import donateIcon from "../img/icons/donate.svg";

export const links = [
    {
        name: "Home",
        path: '/',
    },
    {
        name: "About NAS",
        path: '/about',
        subLinks: [
            { name: "Meet the Team", path: '/about/team' },
        ],
    },
    {
        name: "Peer Befriending",
        path: '/peer-befriending',
    },
    {
        name: "Adaptive Growth Culture",
        path: '/adaptive-growth-culture',
        subLinks: [
            { name: "Additional Reading", path: '/adaptive-growth-culture/reading' },
        ],
    },
    {
        name: "Resources",
        path: '/resources',
        subLinks: [
            { name: "What is Aphasia?", path: '/resources/what-is-aphasia' },
            { name: "NAS Newsletter", path: '/resources/newsletter' },
            { name: "Community Resources", path: '/resources/community' },
        ],
    },
    {
        name: "Contact",
        path: '/contact',
    },
]

// "Join Today!" buttons (Home + Peer Befriending).
// Swap this for the PB interest/intake form URL when it's ready.
export const pbJoinLink = '/contact?pb=1'

export const agcArticleLink = 'https://drive.google.com/file/d/1FmJPGy5DfboNplR8jz1r9EUe5w5SZkto/view'
export const superbStudyLink = 'https://pubmed.ncbi.nlm.nih.gov/33624514/'
export const exlink = [
{
    name: "Shop",
    path: 'https://www.etsy.com/shop/NatlAphasiaSynergy?ref=profile_header',
},
]

export const detailsBios = [    
    {   
        
        id: 1,
        tag: "Trish",
        name: "Trish Hambridge",
        title: "NAS President",
        byline: "has lived with aphasia since her stroke in 2008",
        items: [
            {item: "Worked for AppleCare as a project manager"},
            {item:"Frequently speaks about stroke recovery with speech-language pathologists, students, the public, and people with aphasia or stroke survivors"},
            {item:"Has attended nine conferences and has spoken at four conferences, including Aphasia Access Leadership Summit and the American Speech-Language Hearing Association"},
            {item:"Board Member of the Disability Advisory Committee in Dunedin, Florida"},
            {item:"Board Member of Braemoor Village Condominium Home Owners' Association"},
            {item:"Member of ground-breaking Aphasia Games for Health project; co-author of paper published in Proceedings for the ACM on Human-Computer Interaction"},
            {item:"Member of Voices of Hope for Aphasia, Saint Petersburg, Florida"},
            {item:"Lives in Tampa area, Florida"}
        ]
    },
    
    { 
        id: 2,
        tag: "Amy",
        name: "Amy Walters",
        title: "NAS Vice President",
        byline: "has lived with aphasia since her stroke in 2018",
        items: [
            {item: "Vice President of NAS and Harvard graduate"},
            {item: "Masters of Public Health from Johns Hopkins University"},
            {item:"Worked at Terumo Microvention as Vice President of Regulatory & Clinical Affairs"},
            {item:"Leader in medical device companies including Johnson & Johnson, EV3, AWE Inc., Sequent Medical, and Terumo Microvention of Regulatory & Clinical Affairs throughout her 30-year career"},
            {item:"Board Member of Braemoor Village Condominium Home Owners' Association"},
            {item:"Has an interest in aphasia advocacy work and has presented at neurosurgical intervention conferences to spread awareness"},
            {item:"Member of numerous aphasia groups across the country"},
            {item:"Avid hiking enthusiast and enjoys reading for pleasure"},
            {item:"Lives in Newport Beach, California with her husband, Dave Billingsley"}
        ]
    },
    { 
        id: 3,
        tag: "Helen",
        name: "Helen Ansted",
        title: "NAS Secretary/Treasurer",
        byline: "advocates for people with aphasia",
        items: [
            {item: "Retired from lengthy career as Principal Financial Analyst for the City of Mountain View, California"},
            {item: "Finance Committee member for Notre Dame High School, San Jose, California"},
            {item:"Enjoys gardening, reading, travel and participating in many outdoor activities, with friends and family"},
            {item: "lives in San Jose, California"}
        ]
    },
    { 
        id: 4,
        tag: "Kait",
        name: "Kait Moses",
        title: "NAS Director",
        byline: "is a speech-language pathologist and ally of persons with aphasia",
        items: [
            {item: "Clinical work includes providing intensive speech therapy"},
            {item: "Supporting families through the University of Michigan Aphasia Program"},
            {item:"Member of Aphasia Access and qualified associate of Project BRIDGE (Building Research Initiatives by Developing Group Effort)"},
            {item:"Lives in Michigan"}
        ]
    },
    { 
        id: 5,
        tag: "Bruce",
        name: "Bruce Farrell",
        title: "NAS Director",
        byline: "has lived with aphasia since 2020 after a TBI",
        items: [
            {item: "Worked as Director of Proposals for Plante Moran"},
            {item: "Is a presentations expert"},
            {item:"Was a board member for the Association of Proposal Professionals, where he is a fellow"},
            {item:"Featured in 'Their Words: An Aphasia Documentary Series'"},
            {item:"Enjoys playing guitar and has played in many bands"},
            {item:"Lives with his wife, Jeanne, in Detroit, Michigan"}
        ]
    }
]

export const detailsTeams = [
    {
        id: 1,
        name: "Trish Hambridge",
        title: "Trish - PWA",
        description: "President",
        img: TrishImg,
        link: "/about/team#Trish"
    },
    {
        id: 2,
        name: "Amy Walters",
        title: "Amy - PWA",
        description: "Vice President",
        img: AmyImg,
        link: "/about/team#Amy"
    },
    {
        id: 3,
        name: "Helen Ansted",
        title: "Helen",
        description: "Secretary/Treasurer",
        img: HelenImg,
        link: "/about/team#Helen"
    },
    {
        id: 4,
        name: "Kait Moses",
        title: "Kait",
        description: "Director",
        img: KaitImg,
        link: "/about/team#Kait"
    },
    {
        id: 5,
        name: "Bruce Farrell",
        title: "Bruce - PWA",
        description: "Director",
        img: BruceImg,
        link: "/about/team#Bruce"
    }
];

export const highlightLinks = [
    {
        id: 1,
        title: "Chapter 1: The Diagnosis",
        path: "https://youtu.be/z_Fwv9Tza7w?si=LoeW_sw85pNfI_Ac",
        description: "Chapter 1 introduces the topic of stroke-induced aphasia by describing the symptoms experienced during the fi rst few hours and days following the onset of the stroke."

    },
    {
        id: 2,
        title: "Chapter 2: The First Few Days",
        path: "https://youtu.be/BiNKDI4oKh0?si=XGc-KxpmBBGhpr0z",
        description: "Chapter 2 introduces the topic of adjusting to the impact and challenges of aphasia during the early stage of recovery."
    },
    {
        id: 3,
        title: "Chapter 3: The Recovery",
        path: "https://youtu.be/S_OCPgPxPU4?si=S6WjR1LzcG53DKnX",
        description: "Chapter 3 delves into the journey of recovery, including occupational, physical, and speech therapy. The importance of the team approach and family support are emphasized."
    },
    {
        id: 4,
        title: "Chapter 4: The Psychological Impact",
        path: "https://youtu.be/3TU11YgB_wo?si=ITb2TkAT29RnszOt",
        description: "Chapter 4 explores the emotional and psychological impact of aphasia and provides suggestions on resources to address it."
    },
    {
        id: 5,
        title: "Chapter 5: The Care Partner Perspective",
        path: "https://youtu.be/ycf67ldt6JI?si=B5pJwABsE4hsi3z2",
        description: "Chapter 5 discusses aphasia's effect on care partners and offers reflections on improving the lived experience for all impacted by the condition.",
    }
]

export const highlightVideo = [
    {
        id: 1,
        width: 350,
        height: 196,
        src: "https://www.youtube.com/embed/z_Fwv9Tza7w?si=vR0qu-SFHNOLZ3Mh",
        title: "Chapter 1: The Diagnosis",
        frameborder: 0,
        allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
        referrerpolicy: "strict-origin-when-cross-origin",
        allowfullscreen: true,
        img: "",
        className: "youtube-frame"
    },
    {
        id: 2,
        width: 350,
        height: 196,
        src: "https://www.youtube.com/embed/BiNKDI4oKh0?si=HT74BNJPpj_D7Fcp",
        title: "Chapter 2: The First Few Days",
        frameborder: 0,
        allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
        referrerpolicy: "strict-origin-when-cross-origin",
        allowfullscreen: true,
        img: "",
        className: "youtube-frame"
    },
    {
        id: 3,
        width: 350,
        height: 196,
        src: "https://www.youtube.com/embed/S_OCPgPxPU4?si=7ntgLFRZ2vrXtFM4",
        title: "Chapter 3: The Recovery",
        frameborder: 0,
        allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
        referrerpolicy: "strict-origin-when-cross-origin",
        allowfullscreen: true,
        img: "",
        className: "youtube-frame"
    },
    {
        id: 4,
        width: 350,
        height: 196,
        src: "https://www.youtube.com/embed/3TU11YgB_wo?si=G9JmQj1c2WzZl5dR",
        title: "Chapter 4: The Psychological Impact",
        frameborder: 0,
        allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
        referrerpolicy: "strict-origin-when-cross-origin",
        allowfullscreen: true,
        img: "",
        className: "youtube-frame"
    },
    {
        id: 5,
        width: 350,
        height: 196,
        src: "https://www.youtube.com/embed/ycf67ldt6JI?si=G9JmQj1c2WzZl5dR",
        title: "Chapter 5: The Care Partner Perspective",
        frameborder: 0,
        allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
        referrerpolicy: "strict-origin-when-cross-origin",
        allowfullscreen: true,
        img: "",
        className: "youtube-frame"
    }
    
]

export const buddyProgram = [
    {
        id: 1,
        title: "Aphasia has a large negative impact on mental health and leads to significant social isolation.",
        // CHANGED: Removed "To." typo → "To develop the program"
        paragraph: "To help people address this, National Aphasia Synergy, a peer-led community of people with aphasia (PWA), has successfully launched a free, online peer befriending program, run by volunteers and based on the UK's  SUPERB Trial (Hilari et al., 2021). To develop the program, our speech-language pathologists completed a 6-week training with the SUPERB Trial creators for setting up a co-design and adapt the approach for an online and US context."
    },
    {
        id: 2,
        title: "",
        // CHANGED: Added space → "Throughout the 10 session program"
        paragraph: "In this US program, Allies (PWA who have found ways to thrive) are paired with Buddies (PWA seeking support and connection). The Allies are trained to use their knowledge as peer navigators to provide direct peer support for the self-management and mental health, while offering meaningful connections and socialization. Training includes suicide prevention information and mental health screening. Throughout the 10 session program, Allies may also connect their Buddies with other online support communities and resources to help them stay connected longer term."
    }
]

// data.js
export const waffled = {
  title: "Current participants report:",
  block: [
    "Ally: The one-to-one format is very helpful to maximize the relationship. It's especially great for the newly diagnosed with aphasia, I'm also getting a lot out of it.",
    "Buddy: It is wonderful... It is tough to speak and read and write. [My Ally] is amazing. Patience and persistence AND a friend too. It is tough, but [my Ally] constantly reassuring me."
  ]
};

export const homeSection = [
  {
    type   : "paragraph",
    // CHANGED: Restored "community led by peers" sentence
    content: [
      "National Aphasia Synergy (NAS) is a new non-profit organization community led by peers. The synergy organization was designed to support people with aphasia. NAS was founded by, and will be guided by, people with aphasia. ",
      { span: "This is life participation at its core", className: "color-blue" },
      '. "Aphasia is ',
      { span: "tough blow", className: "color-blue" },
      ', it interferes communication, ',
      { span: "social connection", className: "color-blue" },
      " and ",
      { span: "psychological well-being", className: "color-blue" },
      '."',
      <sup>1</sup>
    ]
  },
  {
    type   : "paragraph",
    content: [
      "Synergy is a national community serving people with aphasia to end the isolation. NAS was developed to help support people with aphasia. Synergy can best serve those with similar needs, by networking local groups and individuals together to share ideas, resources and support in a central location. The synergy website will be available to aphasia groups and individuals across the country. ",
      { span: "Our strength is sharing the stories of successes and challenges", className: "color-blue" },
      ". The synergy website is intended to be a ",
      { span: "rich resource", className: "color-blue" },
      " for people with aphasia. The Synergy plan is for people aphasia to help other people with aphasia thrive."
    ]
  },
  {
    type   : "heading",
    className: "waffle-title",
    text   : "Mission Statement"
  },
  {
    type   : "paragraph",
    content: [
      "NAS is a ",
      { span: "peer-led community of people with ", className: "just-blue" },
      <b>aphasia</b>,
      " driven to:"
    ]
  },
  {
    type: "list",
    className: "mission-list",
    items: [
      { text: "educate", className: "just-blue", extra: " People with aphasia (PWA)" },
      { text: "empower", className: "just-blue", extra: " PWA to use technology to improve communication skills" },
      { text: "promote peer-befriending", className: "just-blue" },
      { text: "develop", className: "just-blue", extra: " a national PWA community" },
      { text: "encourage optimism", className: "just-blue", extra: " and positive outlook in PWA" }
    ]
  },
  {
    type   : "heading",
    className: "waffle-title",
    text   : "Vision Statement"
  },
  {
    type   : "paragraph",
    content: [
      "Our vision is that one day, the population of the United States will have a greater ",
      { span: "understanding of aphasia", className: "just-blue"},
      ", and as a result, all people with aphasia will be ",
      { span: "treated with respect and kindness", className: "just-blue" },
      "."
    ]
  },
  {
    type   : "paragraph",
    className: "smaller",
    content: [<small><sup>1</sup> Katarina Haley, PhD, CCC-SLP, UNC Chapel Hill</small>]
  }
]
export const blogSpot = [
  {
    title      : "Video Blog",
    link       : "https://www.youtube.com/@AphasiaMoments",
    img        : AM_YT,
    alt        : "Aphasia Moments YouTube Channel",
    type: "paragraph",
    content: [
        "Listen to Cheryl Tondreu's 'Aphasia Moment Podcast', on her journey, navigating a new life with the challenges of aphasia. {<br/>} 'In 2019, I was recovering from rotator cuff surgery when I had a stroke. As I continue to recover and learn to live with the challenges of aphasia and apraxia, I will share my story which usually requires me to look back at what happened so I can move forward. It is my hope that by sharing my experiences I can help other stroke survivors and their care partners and help them not only to survive but thrive'."],
    path       : "https://youtube.com/playlist?list=PLgpDY-cXdAojf3X93hMzZysOWpqxnIhFo&si=JU90kBSq7Y7M6nc5"
  }
];

export const detailsFooter = [
    {   
        id: 1,
        title: "Charity Status",
        status: "National Aphasia Synergy Inc is a 501(c)(3) tax exempt organization (Tax ID 87-3330394). Contributions are tax deductible to the extent allowed by law and do not represent payment for goods or services received."
    },
    {   
        id: 2,
        title: "National Aphasia Synergy",
        status: "Based in the Tampa Bay Area, serving the wider United States"
    }
]

export const detailsSocial = [
{
        id: 1,
        icon: fbIcon,
        link: "https://www.facebook.com/WeRSynergy"
},
{       
        id: 2,
        icon: emailIcon,
        // TEMP: info@ mailbox does not exist yet — using Trish until NAS confirms an address
        link: "mailto:trish_hambridge@yahoo.com"
}
]

export const detailsDonate = [
            {
                id: "gLively-donate-btn",
                className: "gLively-donate-btn gLively-btn",
                href: "#!",
                style: {
                    fontSize: "18px",
                    padding: "10px 30px",
                    textDecoration: "none",
                    textAlign: "center",
                    display: "inline-block",
                    border: "medium",
                    boxShadow: "none",
                    color: "#fff",
                    background: "rgb(73, 174, 237)",
                    borderRadius: ".5rem",
                    cursor: "pointer"
                },
                donate: "Donate"
            }
        ]

export const giveLivelyConfig = [
            {
              scriptId: 'give-lively-script',
              scriptSrc: 'https://secure.givelively.org/widgets/branded_donation/national-aphasia-synergy-inc.js',
              widgetId: 'give-lively-widget',
              widgetSrc: 'https://secure.givelively.org/donate/national-aphasia-synergy-inc?ref=sd_widget',
              widgetClass: 'gl-branded-donation-widget'
            }
];
